import { useTranslation } from 'react-i18next';
import { makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    greetingContainer: ({ displayGreeting }: { displayGreeting: boolean }) => ({
      display: !displayGreeting ? 'none' : undefined,
    }),
    trustCertificatesContainer: {
      width: '100%',
      display: 'flex',
    },
    trustCertificatesContainerAbove: {
      marginBottom: '5vh',
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
      '@media (max-height: 520px)': {
        display: 'none',
      },
    },
    trustCertificatesContainerBelow: {
      marginTop: '5vh',
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  }),
);

const useGreeting = (displayGreeting = true) => {
  const { t } = useTranslation('greeting');
  return { t, classes: useStyles({ displayGreeting }) };
};

export default useGreeting;
